import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { applyThemeForPath } from "./utils/rasuTheme";

import Home from "./Components/Home/Home";
import FlightResultsPage from "./Pages/FlightResultsPage/FlightResultsPage";
import Header from "./Components/header/Header";
import Footer from "./Components/Footer/Footer";
import HotelResultsPage from "./Pages/HotelResultsPage/HotelResultsPage";
import HotelDetailsPage from "./Components/Hotel/HotelDetails/HotelDetailsPage";
import FlightDetails from "./Components/FlightDetails/FlightDetails";
import FlightTravellerDetails from "./Components/FlightTravellerDetails/FlightTravellerDetails";
import FlightAddon from "./Components/FlightAddon/FlightAddon";
import FlightReview from "./Components/FlightReview/FlightReview";
import FlightPayment from "./Components/FlightPayment/FlightPayment";
import HotelDetail from "./Components/Hotel/BookingSummaryPage/HotelDetail/HotelDetail";
import GuestDetails from "./Components/Hotel/BookingSummaryPage/GuestDetails/GuestDetails";
import HotelReview from "./Components/Hotel/BookingSummaryPage/HotelReview/HotelReview";
import HotelPayment from "./Components/Hotel/BookingSummaryPage/HotelPayment/HotelPayment";
import HotelConfirmation from "./Components/Hotel/BookingSummaryPage/HotelConfirmation/HotelConfirmation";
import BusResultPage from "./Pages/BusResultsPage/BusResultPage";
import BusDetail from "./Components/Bus/BusDetail/BusDetail";
import BusTravellerDetails from "./Components/Bus/BusTravellerDetails/BusTravellerDetails";
import BusReview from "./Components/Bus/BusReview/BusReview";
import BusPayment from "./Components/Bus/BusPayment/BusPayment";
import Bookingconfirm from "./Components/Bus/Bookingconfirm/Bookingconfirm";
import AgentLogin from "./Components/Login/AgentLogin";
import EmailLogin from "./Components/Login/EmailLogin";
import SetResetMPIN from "./Components/Login/SetResetMPIN";
import TermsandConditions from "./Pages/LegalPages/TermsandConditions";
import PrivacyPolicy from "./Pages/LegalPages/PrivacyPolicy";
import Declaration from "./Pages/LegalPages/Declaration";
import UserAgreement from "./Pages/LegalPages/UserAgreement";
import CancellationRefundpolicy from "./Pages/LegalPages/CancellationRefundpolicy";
import FAQ from "./Pages/LegalPages/FAQ";
import AboutUs from "./Pages/LegalPages/Aboutus";

import BookingSuccess from "./Components/FlightBookingSuccess/BookingSuccess";
import InvoiceTemplate from "./Components/FlightBookingSuccess/Invoice";

import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import Signature from "./Components/Demo/Signature";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./Components/Login/Dashboard/pages/Dashboard";
import PartnerRegister from "./Components/Partner/PartnerRegister";
import PartnerLogin from "./Components/Partner/PartnerLogin";
import PartnerProtectedRoute from "./Components/Partner/PartnerProtectedRoute";
import PartnerLayout from "./Components/Partner/PartnerDashboard/PartnerLayout";
import PartnerOverview from "./Components/Partner/PartnerDashboard/Overview";
import PartnerRequests from "./Components/Partner/PartnerDashboard/Requests";
import PartnerQuotes from "./Components/Partner/PartnerDashboard/Quotes";
import PartnerServices from "./Components/Partner/PartnerDashboard/Services";
import PartnerPackages from "./Components/Partner/PartnerDashboard/Packages";
import PartnerBookings from "./Components/Partner/PartnerDashboard/Bookings";
import PartnerBusinessProfile from "./Components/Partner/PartnerDashboard/BusinessProfile";
import PartnerEarnings from "./Components/Partner/PartnerDashboard/Earnings";
import PartnerReviews from "./Components/Partner/PartnerDashboard/Reviews";
import PartnerDisputes from "./Components/Partner/PartnerDashboard/Disputes";
import PartnerOffers from "./Components/Partner/PartnerDashboard/Offers";
import PartnerReferrals from "./Components/Partner/PartnerDashboard/Referrals";
import PartnerAssistant from "./Components/Partner/PartnerDashboard/Assistant";
import BlogListPage from "./Pages/Blog/BlogListPage";
import BlogDetail from "./Pages/Blog/BlogDetail";
import FlightETicket from "./Components/FlightBookingSuccess/E-Ticket";
import Offers from "./Components/Offers/Offers";
import RasutripAssistant from "./Components/Assistant/RasutripAssistant";
import MarketplaceBrowsePage from "./Pages/Marketplace/MarketplaceBrowsePage";
import ServiceDetailPage from "./Pages/Marketplace/ServiceDetailPage";
import PackageDetailPage from "./Pages/Marketplace/PackageDetailPage";
import TaxiSearchPage from "./Pages/Marketplace/TaxiSearchPage";

function App() {
  const location = useLocation();
  useEffect(() => applyThemeForPath(location.pathname), [location.pathname]);

  return (
    <>
      {/* <Router> */}
      {/* Header handles hiding its own desktop nav bar on the home page (the hero already
          carries the logo/search tabs there) — but its mobile top bar and bottom nav must
          always render, on every page including Home, or mobile users lose their nav entirely. */}
      <Header />
      <ScrollToTop className="mb-4" />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/flight-results" element={<FlightResultsPage />} />
        <Route path="/flight-details" element={<FlightDetails />} />
        <Route path="/traveller-details" element={<FlightTravellerDetails />} />
        <Route path="/addons" element={<FlightAddon />} />
        <Route path="/review" element={<FlightReview />} />
        <Route path="/payment" element={<FlightPayment />} />
        <Route path="/booking/success" element={<BookingSuccess />} />
        <Route path="/booking/invoice" element={<InvoiceTemplate />} />
        <Route path="/booking/e-ticket" element={<FlightETicket />} />

        {/* Hotel */}
        <Route path="/hotel-results" element={<HotelResultsPage />} />
        <Route path="/HotelDetailsPage/:id" element={<HotelDetailsPage />} />
        <Route path="/HotelDetail" element={<HotelDetail />} />
        <Route path="/guest-details" element={<GuestDetails />} />
        <Route path="/Hotelreview" element={<HotelReview />} />
        <Route path="/HotelPayment" element={<HotelPayment />} />
        <Route path="/hotel/confirmation" element={<HotelConfirmation />} />

        {/* Bus */}
        <Route path="/bus-results" element={<BusResultPage />} />
        <Route path="/bus-detail" element={<BusDetail />} />
        <Route
          path="/bus-traveller-details"
          element={<BusTravellerDetails />}
        />
        <Route path="/bus-review" element={<BusReview />} />
        <Route path="/bus-payment" element={<BusPayment />} />
        <Route path="/bus-confirm" element={<Bookingconfirm />} />

        {/* Login */}
        <Route path="/login/customer" element={<EmailLogin />} />
        <Route path="/login/agent" element={<AgentLogin />} />
        <Route path="/set-mpin" element={<SetResetMPIN />} />

        {/* user and agent dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Partner (marketplace business) — separate from Agent/Customer auth */}
        <Route path="/partner/register" element={<PartnerRegister />} />
        <Route path="/partner/login" element={<PartnerLogin />} />
        <Route
          path="/partner/dashboard"
          element={
            <PartnerProtectedRoute>
              <PartnerLayout />
            </PartnerProtectedRoute>
          }
        >
          <Route index element={<PartnerOverview />} />
          <Route path="requests" element={<PartnerRequests />} />
          <Route path="quotes" element={<PartnerQuotes />} />
          <Route path="services" element={<PartnerServices />} />
          <Route path="packages" element={<PartnerPackages />} />
          <Route path="bookings" element={<PartnerBookings />} />
          <Route path="earnings" element={<PartnerEarnings />} />
          <Route path="reviews" element={<PartnerReviews />} />
          <Route path="disputes" element={<PartnerDisputes />} />
          <Route path="offers" element={<PartnerOffers />} />
          <Route path="referrals" element={<PartnerReferrals />} />
          <Route path="assistant" element={<PartnerAssistant />} />
          <Route path="profile" element={<PartnerBusinessProfile />} />
        </Route>

        <Route path="/Offers" element={<Offers />} />

        {/* Marketplace (Taxi services + Holiday packages from verified partners) */}
        <Route path="/taxi" element={<TaxiSearchPage />} />
        <Route path="/marketplace" element={<MarketplaceBrowsePage />} />
        <Route path="/marketplace/services/:id" element={<ServiceDetailPage />} />
        <Route path="/marketplace/packages/:id" element={<PackageDetailPage />} />

        {/* Footer Pages */}
        <Route path="/Aboutus" element={<AboutUs />} />
        <Route path="/terms-and-conditions" element={<TermsandConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<Declaration />} />
        <Route path="/UserAgreement" element={<UserAgreement />} />
        <Route
          path="/CancellationRefundpolicy"
          element={<CancellationRefundpolicy />}
        />

        <Route path="/faq" element={<FAQ />} />

        <Route path="/Blogs" element={<BlogListPage />} />

        {/* Blog Detail Page */}
        <Route path="/blog/:id" element={<BlogDetail />} />

        <Route path="/signature" element={<Signature />} />
      </Routes>
      <Footer />

      <RasutripAssistant />

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
